import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const ConfirmModal = ({ visible, message, onConfirm, onCancel }) => {
  const footer = (
    <div>
      <Button label="Não" icon="pi pi-times" onClick={onCancel} className="p-button-text" />
      <Button label="Sim" icon="pi pi-check" onClick={onConfirm} autoFocus />
    </div>
  );

  return (
    <Dialog 
      header="Confirmação" 
      visible={visible} 
      style={{ width: '350px' }} 
      footer={footer} 
      onHide={onCancel}
      modal
    >
      <div className="confirmation-content">
        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
        <span>{message}</span>
      </div>
    </Dialog>
  );
};

export default ConfirmModal;
